import { t } from '@transifex/native';

import * as flashActions from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create as modelsCreate } from 'pkg/api/models/actions';
import type { EventComment } from 'pkg/api/models/event_comment';
import * as sdk from 'pkg/core/sdk';

export const create = async (
	organizationId: number,
	eventId: number,
	comment: string
): Promise<[boolean, EventComment]> => {
	const [request, response] = await modelsCreate<
		{ comment: string },
		models.eventComment.EventComment
	>(endpoints.Events.AddComment(organizationId, eventId), { comment });

	if (!request.ok) {
		return [false, null];
	}

	return [true, response];
};

export const update = async (
	organizationId: number,
	id: number,
	comment: string
) => {
	const request = await sdk.patch(
		endpoints.Events.UpdateComment(organizationId, id),
		{},
		{ comment }
	);

	if (request.ok) {
		const resp = await request.json();

		return [true, resp];
	}

	return [false, null];
};

export const remove = async (organizationId: number, id: number) => {
	const req = await sdk.destroy(
		endpoints.Events.DeleteComment(organizationId, id)
	);

	if (req.ok) {
		flashActions.show({
			title: t('Successfully removed comment.'),
		});

		return true;
	}

	flashActions.show({
		title: t('Something went wrong.'),
	});

	return false;
};
